import React from 'react';
import Stakeholder from '../../../../../components/Forms/stakeholder/index';

function CADDStakeholder() {
  return <Stakeholder module="cadd" view="stakeholders" drawerTitle="Create Stakeholder"/>
};

export default CADDStakeholder;
